import {Metadata, RemoteConstantsModel} from "../models/remoteConstants.model";
import {CommandBase} from "./commandBase";
import {MetadataCollection} from "./metadataValue.command";

export class MetadataIdCommand extends CommandBase {
    collection: MetadataCollection;
    uid: string;
    id: string;

    constructor(collection: MetadataCollection, uid: string, id: string) {
        super();
        this.collection = collection;
        this.uid = uid;
        this.id = id;
    }

    execute(data: RemoteConstantsModel): boolean {
        if (this.uid === '' || this.id === '') {
            return false;
        }

        switch (this.collection) {
            case MetadataCollection.Units:
                return this.changeInCollection(data.unitAttributes);
            case MetadataCollection.Buildings:
                return this.changeInCollection(data.buildingAttributes);
            case MetadataCollection.Rewards:
                return this.changeInCollection(data.rewards);
            case MetadataCollection.TechActions:
                return this.changeInCollection(data.techActionAttributes);
            case MetadataCollection.TechPassives:
                return this.changeInCollection(data.techPassiveAttributes);
            default:
                return false;
        }
    }

    // id is the type name — just update the field. No localization re-keying, no array rewriting.
    private changeInCollection(attributes: Metadata[]): boolean {
        const index = attributes.findIndex(a => a.uid === this.uid);
        if (index < 0) return false;
        attributes[index].id = this.id;
        return true;
    }
}
